import React from "react";
import { Box } from "@mui/material";
import { TabsProps } from "./types";
import { TabsContainer, TabButton } from "./style";

const TabsCst: React.FC<TabsProps> = ({ tabs, activeKey, onChange }) => {
  const handleClick = (tabKey: string, disabled?: boolean) => {
    if (disabled) return;
    if (tabKey === activeKey) return;
    onChange(tabKey);
  };

  return (
    <TabsContainer>
      {tabs.map((tab) => (
        <TabButton
          key={tab.key}
          active={tab.key === activeKey}
          disabled={tab.disabled}
          onClick={() => handleClick(tab.key, tab.disabled)}
        >
          {tab.icon ? (
            <Box
              sx={{ display: "inline-flex", alignItems: "center", gap: 0.75 }}
            >
              {tab.icon}
              <span>{tab.label}</span>
            </Box>
          ) : (
            tab.label
          )}
        </TabButton>
      ))}
    </TabsContainer>
  );
};

export default TabsCst;
